<script lang="ts">
export default { name: 'Success' };
</script>

<script setup lang="ts">
import { useSuccess } from './useSuccess';

const { successType, successComponent, showItems } = useSuccess();
</script>

<template>
  <component
    :is="successComponent"
    :success-type="successType"
    :card-products="showItems"
  />
</template>
